import RecentTransactions from '../../pages/Transactions/RecentTransactions';
import React, { useState } from 'react';
import { transactionStore } from '../../stores';
import { observer } from 'mobx-react';

const RecentTransactionsContainer = ({
	goToEditIncomeModal,
	goToEditExpenseModal,
	filteredTransactions,
	setFilteredTransactions,
	getUpdateDebtModal,
	setViewMoreExpense,
	setUpdateTransaction,
	refresh,
	loading,
	setOpenTagModal,
	setViewMoreIncome,
}) => {
	const [expenseDebtTable, setExpenseDebtTable] = useState(false);
	const [incomeTable, setIncomeTable] = useState(true);
	const [expenseTable, setExpenseTable] = useState(false);
	const [debtTable, setDebtTable] = useState(false);

	const allExpenseDebtTable = () => {
		setExpenseDebtTable(true);
		setExpenseTable(false);
		setIncomeTable(false);
		setDebtTable(false);
	};

	const allIncomeTable = () => {
		setIncomeTable(true);
		setExpenseDebtTable(false);
		setDebtTable(false);
		setExpenseTable(false);
	};

	const allExpensesTable = () => {
		setExpenseTable(true);
		setExpenseDebtTable(false);
		setIncomeTable(false);
		setDebtTable(false);
	};

	const allDebtorsTable = () => {
		setExpenseTable(false);
		setExpenseDebtTable(false);
		setIncomeTable(false);
		setDebtTable(true);
	};

	return (
		<RecentTransactions
			allExpenseDebtTable={allExpenseDebtTable}
			incomeTable={incomeTable}
			expenseTable={expenseTable}
			getUpdateDebtModal={getUpdateDebtModal}
			refresh={refresh}
			loading={loading}
			debtTable={debtTable}
			transactions={transactionStore.transactions}
			expenseDebtTable={expenseDebtTable}
			allIncomeTable={allIncomeTable}
			allExpensesTable={allExpensesTable}
			allDebtorsTable={allDebtorsTable}
			goToEditIncomeModal={goToEditIncomeModal}
			goToEditExpenseModal={goToEditExpenseModal}
			filteredTransactions={filteredTransactions}
			setFilteredTransactions={setFilteredTransactions}
			setViewMoreExpense={setViewMoreExpense}
			setUpdateTransaction={setUpdateTransaction}
			setOpenTagModal={setOpenTagModal}
			setViewMoreIncome={setViewMoreIncome}
		/>
	);
};

export default observer(RecentTransactionsContainer);
